import React from 'react'
import { HeroSection } from './HeroSection'
import { CategoryCards } from './CategoryCards'
import { BlogPosts } from './BlogPosts'
import OlderArticles from './OlderArticles'


const Blog = () => {
  return (
    <main>
        <HeroSection />
        <CategoryCards />
        <BlogPosts />
        <OlderArticles />
    </main>
  )
}

export default Blog
